import { ErrorView } from '@gasbi/shared/web/components/ErrorBoundary';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useGetOnboardingStatusQuery } from '@/features/onboarding/onboardingApi';
import { OnboardingStatus } from '@/features/onboarding/types';
import { Pages } from '@/pages';

export const OnboardingGate = () => {
  const { pathname } = useLocation();
  const { data, isLoading, isError } = useGetOnboardingStatusQuery();

  if (isLoading) {
    return null;
  }

  if (isError) {
    return <ErrorView />;
  }

  const isOnboarding = data?.status === OnboardingStatus.Onboarding;

  if (isOnboarding && pathname !== Pages.ONBOARDING) {
    return <Navigate to={Pages.ONBOARDING} replace />;
  }

  if (!isOnboarding && pathname === Pages.ONBOARDING) {
    return <Navigate to='/' replace />;
  }

  return <Outlet />;
};
